import { FC } from 'react'
import { cn } from '@wellesley/ui'
import { AppsLink } from '@wellesley/router'
import UserInfoPopup from 'components/UserInfoPopup'
import { getDisplayUsername, UserAvatar } from '@wellesley/user'
import useProfile from 'hooks/useProfile'
import useCopyToClipboard from 'hooks/useCopyToClipboard'
import { getUserImage } from 'helpers/getUserImage'
import { getUserNameWithDomain } from 'helpers/getUserNameWithDomain'

import type { AboutServerSectionProps } from '../../types'

type ContactsProps = Pick<AboutServerSectionProps, 'contacts'>

const Contacts: FC<ContactsProps> = ({ contacts }) => {
  const username = contacts?.username

  const [user] = useProfile({ username: username || '' })

  const [localPart, domain] = contacts?.email?.split('@') || []

  const hasUser = user && username

  const [copyEmail] = useCopyToClipboard({
    textToCopy: contacts?.email || '',
    toastMsg: 'Email is copied to clipboard',
  })

  if (!contacts) return null

  return (
    <div className="flex flex-col">
      {user && username && (
        <UserInfoPopup hideFollowButton username={getUserNameWithDomain(user)}>
          <AppsLink
            to="/@/:username"
            props={{ username: getUserNameWithDomain(user) }}
          >
            <div className="flex gap-xxs">
              <UserAvatar
                size={40}
                name={user.displayName}
                imgUrl={getUserImage({ user })}
              />
              <div>
                {user && (
                  <p className="text-base font-medium text-gray-900">
                    {user.displayName}
                  </p>
                )}
                {user && (
                  <p className="text-base text-gray-500">
                    {getDisplayUsername(getUserNameWithDomain(user))}
                  </p>
                )}
              </div>
            </div>
          </AppsLink>
        </UserInfoPopup>
      )}
      <div className={hasUser ? 'ml-xxl' : ''}>
        {contacts?.email && (
          <button
            onClick={copyEmail}
            className={cn(
              'mt-xxxs cursor-pointer text-base text-blue-500 hover:underline',
              { 'pl-xxs': hasUser },
            )}
          >
            <span>{localPart}</span>
            <span>@</span>
            <span>{domain}</span>
          </button>
        )}
      </div>
    </div>
  )
}

export default Contacts
